/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/Button/index.js
 * Created:       Wed Mar 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Nov 04 2025
 */

import React from "react";
import { getImage } from "../../../_utils";

/**
 * The Button component will render a button with the "label" prop as the text.
 * The style of the button will be determined based on the value of the optional
 * prop "image".
 *
 * @param { string } label -> The string used as the text for the button.
 *
 * @param { function } onClick ->
 *
 * @param { string } image ->
 */
export default function Button({ label, name, onClick, type, fullWidth, subdued, id, borderLess=false, image = null, disabled = false, children}) {
  let style = (image) ? "gc__media_button" : "";

  const fullWidthClass = fullWidth === true ? "gc__full_width_btn" : "";
  const subduedClass = subdued === true ? "gc__subdued_btn" : "";
  const borderLessClass = borderLess === true ? "gc__borderless_btn" : "";
  return (
    <div className={"gc__button_container"} >
      <button
        type={type}
        id={id}
        onClick={onClick}
        className={`gc__btn ${style} ${fullWidthClass} ${subduedClass} ${borderLessClass}`}
        name={name}
        disabled={disabled}
      >
        <div>
          {
            image ?
              <img className={"gc__icon"} src={getImage(image)} alt="" />
              : <></>
          }
        </div>
        {children}
      </button>
    </div>
  )
}
